module.exports = __webpack_public_path__ + "img/7.81ef283f.jpg";